import { useState } from "react";
import { Box, Button, Text, Input, Link } from "@postenbring/hedwig-react";

import "./calculator-delivery-time.scss";

export const DeliveryCalculator = ({
    title,
    description,
    sendingFrom,
    sendingTo,
    placeholder,
    deliveryTomorrow,
    deliveryMessage,
    deliverBy,
    noService,
    handInTime,
    btnTxt,
    invalidPostCodeMessage,
    serviceUrl,
    deliveryTime,
    deliveryFrom,
    deliveryTo,
    deliveryBack,
}) => {
    const [result, setResult] = useState("");
    const [fromPostCode, setFromPostCode] = useState("");
    const [fromValidationMessage, setFromValidationMessage] = useState("");
    const [toValidationMessage, setToValidationMessage] = useState("");
    const [toPostCode, setToPostCode] = useState("");
    const [handInMessage, setHandInMessage] = useState("");
    const [fromCity, setFromCity] = useState("");
    const [toCity, setToCity] = useState("");

    const updateFromCode = (code) => {
        setFromPostCode(code);
        setFromValidationMessage("");
        resetMessages();
    };

    const updateToCode = (code) => {
        setToPostCode(code);
        setToValidationMessage("");
        resetMessages();
    };

    const resetMessages = () => {
        setHandInMessage("");
        setResult("");
    };

    const getDeliveryTimes = async () => {
        const isNumber = /^[0-9]+$/;
        let canCalculate = true;

        if (fromPostCode.length < 4 || !isNumber.test(fromPostCode)) {
            setFromValidationMessage(invalidPostCodeMessage);
            canCalculate = false;
        }

        if (toPostCode.length < 4 || !isNumber.test(toPostCode)) {
            setToValidationMessage(invalidPostCodeMessage);
            canCalculate = false;
        }

        try {
            // Fetch fromPostCode data
            const fromResponse = await fetch(
                `https://adressesok.posten.no/api/v1/addresses.json?address=postnummer:${fromPostCode}`,
            );
            const fromData = await fromResponse.json();

            if (fromData.status === "not_found") {
                setFromValidationMessage(invalidPostCodeMessage);
                canCalculate = false;
            } else {
                let fromCity = fromData.addresses[0].city;
                setFromCity(fromCity);
            }

            // Fetch toPostCode data
            const toResponse = await fetch(
                `https://adressesok.posten.no/api/v1/addresses.json?address=postnummer:${toPostCode}`,
            );
            const toData = await toResponse.json();

            if (toData.status === "not_found") {
                setToValidationMessage(invalidPostCodeMessage);
                canCalculate = false;
            } else {
                let toCity = toData.addresses[0].city;
                setToCity(toCity);
            }

            if (canCalculate) {
                const deliveryResponse = await fetch(
                    `${serviceUrl}?toPostCode=${toPostCode}&fromPostCode=${fromPostCode}`,
                );
                const deliveryDate = await deliveryResponse.json();
                caluclateDelivery(deliveryDate);
            } else {
                canCalculate = true;
            }
        } catch (error) {
            setResult("");
            setHandInMessage("");
        }
    };

    const caluclateDelivery = (response) => {
        var deliveryDate = new Date(
            response.deliveryDate.year +
                "-" +
                response.deliveryDate.month +
                "-" +
                response.deliveryDate.day,
        );
        var deliveryDateAsString = response.deliveryDate.day + "." + response.deliveryDate.month;
        var deliveryTime = response.deliveryDate.hour + "." + response.deliveryDate.minute;

        var today = new Date();
        var tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);

        if (response.deliveryDate.year == undefined) {
            setResult(noService);
            return;
        }

        if (tomorrow.toDateString() == deliveryDate.toDateString()) {
            setHandInMessage(handInTime);
            setResult(deliveryMessage + " " + deliveryTomorrow + " " + deliveryTime);
        } else {
            setHandInMessage(handInTime);
            setResult(
                deliveryMessage + " " + deliveryDateAsString + " " + deliverBy + " " + deliveryTime,
            );
        }
    };

    return (
        <Box className="delivery-calculator">
            <Text as="h3" variant="h3-title" className="hds-mb-20-24">
                {title}
            </Text>
            {description && !result && (
                <Text as="p" variant="body" className="hds-mb-20-24">
                    {description}
                </Text>
            )}
            {!result && (
                <div className="delivery-calculator-inputs">
                    <Input
                        label={sendingFrom}
                        placeholder={placeholder}
                        id="sendingFrom"
                        maxLength={4}
                        className="hds-mb-20-24"
                        onChange={(event) => updateFromCode(event.target.value)}
                        errorMessage={fromValidationMessage}
                    />
                    <Input
                        label={sendingTo}
                        placeholder={placeholder}
                        id="sendingTo"
                        maxLength={4}
                        className="hds-mb-20-24"
                        onChange={(event) => updateToCode(event.target.value)}
                        errorMessage={toValidationMessage}
                    />
                </div>
            )}

            {result && (
                <>
                    <Text as="p" variant="body" className="hds-mb-20-24">
                        {deliveryTime} {deliveryFrom}{" "}
                        <b>
                            {fromPostCode} {fromCity}
                        </b>{" "}
                        {deliveryTo}{" "}
                        <b>
                            {toPostCode} {toCity}
                        </b>
                    </Text>
                    <Text as="p" variant="body" className="hds-mb-20-24">
                        {result}
                    </Text>

                    {handInMessage && (
                        <Text as="p" className="hds-mb-20-24">
                            <Link href="http://www.posten.no/kart">{handInMessage}</Link>
                        </Text>
                    )}
                    <Button data-color="posten" variant="secondary" onClick={() => resetMessages()}>
                        {deliveryBack}
                    </Button>
                </>
            )}
            {!result && (
                <Button data-color="posten" variant="primary" onClick={() => getDeliveryTimes()}>
                    {btnTxt}
                </Button>
            )}
        </Box>
    );
};
